export default "__VITE_ASSET__C88Of9E$__"